import { useAuthUrl } from 'features/auth/hooks/useAuthUrl/useAuthUrl';
import authenticatedFetch from 'services/rest/authenticatedFetch';
import { FeatureFlagKey } from 'services/statsig/types';
import { Headers } from 'shared/constants/headers';

interface Challenge {
  challengeType: string;
  challengeId: string;
  challengeContext: string;
  challengeState: string;
}

export interface AcceptReactivationChallengeData {
  challengeId: string;
  identityId: string;
  acceptOptions: {
    otpOption?: {
      otpCode: string;
    };
    ssnVerifyOption?: {
      ssn: string;
    };
  };
}

export interface AcceptReactivationChallengeResponse {
  challengeVerified?: boolean;
  errorMessage?: string;
  challengeContext?: string;
  challenges?: Challenge[];
  title?: string;
  errorCode?: string;
  message?: string;
}

function useAcceptReactivationChallenges() {
  const authUrl = useAuthUrl(
    FeatureFlagKey.ACCEPT_CHALLENGE_USE_K8S_AUTH_SERVICE,
  );

  const postAcceptReactivationChallenge = async (
    data: AcceptReactivationChallengeData,
    headers?: Headers,
  ) => {
    const reqHeaders = {
      ...headers,
    };

    const response = await authenticatedFetch(`${authUrl}/accept-challenge`, {
      method: 'POST',
      cache: 'no-cache',
      body: JSON.stringify({
        ...data,
      }),
      headers: reqHeaders,
    });
    return response.json() as Promise<AcceptReactivationChallengeResponse>;
  };

  return { postAcceptReactivationChallenge };
}

export default useAcceptReactivationChallenges;
